import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Produk from '../views/ProdukView.vue'
import AkunView from '../views/AkunView.vue'
import ProdukDetail from '../views/ProdukDetail.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import TentangView from '../views/TentangView.vue'
import SearchView from '../views/SearchView.vue'
import KeranjangView from '../views/KeranjangView.vue'
import WishlistView from '../views/WishlistView.vue'
import CheckoutView from '../views/CheckoutView.vue'

function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    const jwtPayload = JSON.parse(window.atob(localStorage.token.split('.')[1]))
    if (jwtPayload.exp < Date.now() / 1000) {
      localStorage.removeItem('token');
      localStorage.removeItem('profile');
      next('/login');
    }  
    next();
  } else {
    next('/login');
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/kategori',
    name: 'kategori',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/KategoriView.vue')
  },
  {
    path: '/produk',
    name: 'produk',
    component: Produk
  },
  {
    path: '/produk_detail/:id',
    name: 'produk_detail',
    component: ProdukDetail
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    beforeEnter: loggedInRedirectDashboard
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/tentang',
    name: 'tentang',
    component: TentangView
  },
  {
    path: '/pencarian',
    name: 'pencarian',
    component: SearchView
  },
  {
    path: '/keranjang',
    name: 'keranjang',
    component: KeranjangView,
    beforeEnter: isLoggedIn
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    component: WishlistView,
    beforeEnter: isLoggedIn
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutView,
    beforeEnter: isLoggedIn
  },
  {
    path: '/akun',
    name: 'akun',
    component: AkunView,
    beforeEnter: isLoggedIn
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
